module.exports = __webpack_public_path__ + "img/laptop.4fe77fb7.png";